import type { StandardTextFieldProps } from '@mui/material';
import { TextField, type TextFieldProps } from '../../Inputs';

type LegacyInputProps = Omit<TextFieldProps, 'slotProps'> & {
  InputProps?: StandardTextFieldProps['InputProps'];
  InputLabelProps?: StandardTextFieldProps['InputLabelProps'];
  inputProps?: StandardTextFieldProps['inputProps'];
};

export const LegacyInput = ({
  InputProps,
  InputLabelProps,
  inputProps,
  ...rest
}: LegacyInputProps) => (
  <TextField
    {...rest}
    slotProps={{
      input: InputProps,
      inputLabel: InputLabelProps,
      htmlInput: inputProps,
    }}
  />
);
